export enum StepEnum{
    BOOKING = 1,
    USER_FORM = 2,
    ADDON = 3,
    PAYMENT = 4
} 